import { mapDTO } from '@twistezo/ts-dto-mapper'

import { Schema } from '../../../schema'
import { Variables } from './types'

type From = Schema
type To = Pick<Variables, 'nativeTemplateId'>

export const toDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((schema: From): To => {
    const { nativeTemplateId } = schema

    return {
      nativeTemplateId: Number(nativeTemplateId),
    }
  })
